class EventDay {
	constructor(el, events) {
		this.el = el;
		this.events = events;
		this.button = this.el.querySelector('[data-event-toggle]');
		this.target = this.el.querySelector(`[data-event-content="${this.button.dataset.eventToggle}"]`);

		this.button.addEventListener('click', (e) => {
			e.preventDefault();

			if (this.el.classList.contains('is-open')) {
				this.close();
			} else {
				this.open();
			}
		});

		this.target.addEventListener('transitionend', () => {
			if (!this.el.classList.contains('is-open')) {
				this.target.style.visibility = 'hidden';
			}
		});
	}

	open() {
		this.target.style.visibility = 'visible';
		this.target.style.height = this.target.scrollHeight + 'px';
		this.button?.setAttribute('aria-expanded', true);
		this.el.classList.add('is-open');
		// this.events.closeOthers(this);
	}

	close() {
		this.target.style.height = 0 + 'px';
		this.button?.setAttribute('aria-expanded', false);
		this.el.classList.remove('is-open');
	}
}

export default class Events {
	static init(e) {
		const els = e.detail.element.querySelectorAll('[data-events]');
		els.forEach((el) => new this(el));
	}

	constructor(el) {
		this.el = el;
		this.eventDays = Array.from(this.el.querySelectorAll('[data-event-day]')).map((el) => new EventDay(el, this));

		if (this.eventDays.length !== 0) {
			this.eventDays[0].open();
		}
	}

	closeOthers(opened) {
		this.eventDays.forEach((eventDay) => {
			if (eventDay !== opened) {
				eventDay.close();
			}
		});
	}
}
